import React from "react";

export default function AccountSettingsPage() {
  return <h2>Account Settings</h2>;
}
